
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.583 16.845a1.013 1.013 0 01-1.428 0 5.03 5.03 0 010-7.107l5.268-5.268a5.03 5.03 0 017.107 0 5.03 5.03 0 010 7.107l-1.444 1.444a1.004 1.004 0 01-1.421-1.417l1.437-1.444a2.997 2.997 0 000-4.262 2.997 2.997 0 00-4.262 0l-5.257 5.257a2.997 2.997 0 000 4.262.979.979 0 010 1.428zm2.834-5.69a1.013 1.013 0 011.428 0 5.03 5.03 0 010 7.107l-5.268 5.268a5.03 5.03 0 01-7.107 0 5.03 5.03 0 010-7.107l1.44-1.44a1.004 1.004 0 011.42 0l.001.002c.392.393.392 1.03 0 1.422L5.898 17.84a2.997 2.997 0 000 4.262 2.997 2.997 0 004.262 0l5.257-5.257a2.997 2.997 0 000-4.262.979.979 0 010-1.428z","fill":"currentColor"}})])
          )
        }
      }
    